import { TOOLBAR_HEIGHT } from 'Util/constants'
import type { DialogProps } from '@mui/material'
import { Dialog, styled } from '@mui/material'
import type { ReactNode } from 'react'

const StyledDialog = styled(Dialog)(({ theme }) => ({
  zIndex: theme.zIndex.drawer, // Lower than app bar which is drawer + 1
  '& .MuiBackdrop-root': {
    top: TOOLBAR_HEIGHT,
    position: 'fixed'
  },
  '& .MuiDialog-container': {
    alignItems: 'flex-start',
    paddingTop: `${TOOLBAR_HEIGHT + 40}px`
  },
  '& .MuiDialogTitle-root + .MuiDialogContent-root': {
    paddingTop: theme.spacing(2) // Override MUI's specific selector that removes padding when DialogTitle is present
  }
}))

interface ForcedDialogProps extends Omit<DialogProps, 'children'> {
  open: boolean
  children: ReactNode
}

function ForcedDialog({
  open,
  children,
  maxWidth = 'xs',
  ...dialogProps
}: Readonly<ForcedDialogProps>) {
  return (
    <StyledDialog open={open} disableEscapeKeyDown fullWidth maxWidth={maxWidth} {...dialogProps}>
      {children}
    </StyledDialog>
  )
}

export default ForcedDialog
